import { isEmpty } from "lodash";

const createEmptyRule = () => ({
  /**
   * @returns an Empty rule object.
   */

  startTime: "",
  endTime: "",
  week_days: [],
  month_days: [],
  months: [],
});

export default (weeklyRuleObject, selectedMonths) => {
  /**
   * @param {Object(<scheduleName: String, rules: Array[<Object>]>)} weeklyRuleObject
   * @param {String} selectedMonths months to repeat weekly rule
   * @returns {Object(<scheduleName: String, rules: Array[<Object>]>)} scheduleObject
   */

  if (isEmpty(weeklyRuleObject)) {
    return null;
  }
  const rules = [];
  const rulesList = weeklyRuleObject.rules;
  const scheduleName = weeklyRuleObject.scheduleName;

  const getMonth = selectedMonths.map((month) => month);

  for (let i = 0; i < rulesList.length; i++) {
    const newRule = createEmptyRule();

    newRule.startTime = rulesList[i].startTime;
    newRule.endTime = rulesList[i].endTime;
    newRule.week_days = rulesList[i].week_days;
    newRule.month_days = rulesList[i].month_days;
    newRule.months = [...new Set([...rulesList[i].months, ...getMonth])];

    rules.push(newRule);
  }

  return {
    scheduleName,
    rules,
  };
};
